export const login = {
  fields: [
    {
      name: 'username',
      label: 'User ID',
      type: 'text',
      placeholder: 'Enter your username', 
      required: false,
    },
    {
      name: 'password',
      label: 'Password',
      type: 'password',
      placeholder: 'Enter your password',
      required: false,
    },
    
    {
      name: 'forgotPassword',
      label: 'Forgot Password?',
      type: 'forgotPassword',
      link: 'Enter your password',
    },
  ],
  buttons: [
    {
      label: 'Log In',
      action: 'next',
      type: 'button',
      className: 'btn-next',
    }
  ],
};
